import { writable } from "svelte/store";

export function importFinishedCallback() {
  changeListeners.forEach((cl) => cl());
}

const changeListeners = [];
export function storage(key, initValue) {
  key = "lapcnt-" + key;
  const store = writable(initValue);
  if (!window) return store;

  const storedValueStr = localStorage.getItem(key);
  if (storedValueStr != null) store.set(JSON.parse(storedValueStr));

  store.subscribe((val) => {
    if ([null, undefined].includes(val)) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(val));
    }
  });

  const localStorageChange = () => {
    const storedValueStr = localStorage.getItem(key);
    if (storedValueStr == null) return;

    const localValue = JSON.parse(storedValueStr);
    store.set(localValue);
  };

  changeListeners.push(localStorageChange);

  window.addEventListener("storage", localStorageChange);

  return store;
}
